import { memo } from 'react';
import classNames from 'classnames';
import styles from './PillBadge.module.scss';

const PillBadge = ({
  children,
  customCss = 'bg-primary text-white text-uppercase',
  id,
  onPdp = false,
  position = 'top_right',
}) => {
  return (
    <div
      className={classNames(
        'font-sofia fw-700 rounded-pill text-center',
        styles.badge,
        styles[position],
        customCss,
        {
          'fs-sm-9 fs-8 px-10 py-3': onPdp,
          [styles.card]: !onPdp,
          'py-1 py-lg-3': !onPdp,
        }
      )}
      data-value={id}
    >
      {children}
    </div>
  );
};

export default memo(PillBadge);
